<template>
    <div class="view-switcher">
        <div class="view-item" @click="selectMainTable">
            <i class="material-icons">table_chart</i>
            Main Table
        </div>
        <a-divider />
        <div class="view-item" v-for="view in table.views" :key="view._id" @click="selectView(view)">
            <i class="material-icons">keyboard_tab</i>
            {{ view.name }}
            <i class="material-icons edit-icon" @click.stop="editView(view)">edit</i>
        </div>
        <div class="view-item add-new" @click="createNewView">
            <i class="material-icons">add</i>
            New View
        </div>
        <a-divider />
        <div class="footer-text">
            Create Views to persist filtering, sorting, and hiding fields without changing the main Table.
        </div>
    </div>
</template>

<script>
export default {
    name: "ViewSwitcher",
    props: {
        views: {
            type: Array,
            default: () => [],
        },
        table: {
            type: Object,
            required: true,
        },
    },
    methods: {
        selectMainTable() {
            this.$emit("show-view", null);
        },
        selectView(view) {
            this.$emit("show-view", view);
        },
        editView(view) {
            this.$emit("edit-view", view);
        },
        createNewView() {
            this.$emit("create-new-view");
        },
    },
};
</script>

<style scoped lang="scss">
.view-switcher {
    .ant-divider {
        margin: 5px 0;
    }

    .view-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        cursor: pointer;

        &:hover {
            background-color: #f5f5f5;
        }

        .material-icons {
            margin-right: 8px;
        }

        .edit-icon {
            margin-left: auto;
            color: #1890ff;

            &:hover {
                color: #40a9ff;
            }
        }

        &.add-new {
            color: #1890ff;

            .material-icons {
                color: #1890ff;
            }
        }
    }

    .footer-text {
        padding: 8px 12px;
        font-size: 12px;
        color: #999;
        background-color: #f5f5f5; // Arka plan rengi eklendi
    }
}
</style>
